export function applyDocumentSeo(title: string | null | undefined, description: string | null | undefined): void {
  if (title) document.title = title;
  if (!description) return;
  let element = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!element) {
    element = document.createElement('meta');
    element.name = 'description';
    document.head.appendChild(element);
  }
  element.content = description;
}
